import React, { Component } from 'react';
import { Input, Checkbox, Select } from 'antd';
import { COLORS } from '../../pages/theme';

const type_options=[
    {text:"String",value:'string'},
    {text:"Integer",value:'integer'},
    {text:"Boolean",value:'boolean'},
    {text:"Decimal",value:'decimal'},
    
]
class BasicConfigForm extends Component {
    render() {
        let count = this.props.count || 1;
        // console.log("value is", this.props)
        let data = this.props.value || {};
        let validation=data.validation||{};
        if(validation.required==null){
            this.props.onChange({
                ...data,
                validation:{
                    ...validation,
                    required:false
                }
            })
        }

        return <div style={{
            width:'100%'
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                // justifyContent: 'space-between',
                flexWrap: 'wrap',
                alignItems: 'center',
                padding:4,
                borderBottom:`1px solid ${COLORS.border_basic}`
            }}>
                <div style={{
                    flex: 1,
                    minWidth: '50%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',paddingRight:6,marginBottom:8
                }}>
                    <span style={{
                        width:100
                    }}>Name:</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Input
                    style={{width:200}}
                        value={data.name}
                        onChange={(e) => {
                            this.props.onChange({
                                ...data,
                                name: e.target.value
                            })
                        }}
                        placeholder="Name"
                    />

                </div>
                <div style={{
                    flex: 1,
                    minWidth: '50%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',paddingRight:6,marginBottom:8
                }}>
                    <span style={{
                        width:100
                    }}>Display Name:</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Input
                    style={{width:200}}
                        value={data.display_name}
                        onChange={(e) => {
                            this.props.onChange({
                                ...data,
                                display_name: e.target.value
                            })
                        }}
                        placeholder="Display Name"
                    />

                </div>
                <div style={{
                    flex: 1,
                    minWidth: '50%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',paddingRight:6,marginBottom:8
                }}>
                    <span style={{
                        width:100
                    }}>Required:</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox
                    checked={validation.required}
                    onChange={(e)=>{
                        this.props.onChange({
                            ...data,
                            validation:{
                                ...validation,
                                required:e.target.checked
                            }
                        })
                    }}
                    />
                </div>
                <div style={{
                    flex: 1,
                    // minWidth: 300,
                    minWidth:'50%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',paddingRight:6,marginBottom:8
                }}>
                    <span style={{
                        width:100
                    }}>Type:</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Select
                    style={{
                        width:200
                    }}
                    placeholder="Type"
                    value={validation.type}
                    onChange={(value)=>{
                        this.props.onChange({
                            ...data,
                            validation:{
                                ...validation,
                                type:value
                            }
                        })
                    }}
                    >
                        {type_options.map((item)=>{
                            return <Select.Option
                            key={item.value}
                            value={item.value}
                            >{item.text}</Select.Option>
                        })}

                    </Select>
                    {/* <Checkbox
                    checked={validation.required}
                    onChange={(e)=>{
                        this.props.onChange({
                            ...data,
                            validation:{
                                ...validation,
                                required:e.target.checked
                            }
                        })
                    }}
                    /> */}
                </div>
            </div>
        </div>
        return (
            <div style={{
                width: '100%'
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    flexWrap: 'nowrap'
                }}>
                    <span style={{
                        maxWidth: 300,
                        flex: 1, textAlign: 'center',
                        padding: 4
                    }}>Name</span>
                    <span style={{
                        maxWidth: 300,
                        flex: 1,
                        textAlign: 'center', padding: 4
                    }}>Display Name</span>
                    <span style={{
                        maxWidth: 300,
                        flex: 1, textAlign: 'center', padding: 4
                    }}>Required</span>
                    <span style={{
                        maxWidth: 300,
                        flex: 1, textAlign: 'center', padding: 4
                    }}>Type</span>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    flexWrap: 'nowrap'
                }}>
                    <div style={{
                        maxWidth: 300,
                        flex: 1, textAlign: 'center', padding: 4
                    }}>
                        <Input
                            value={data.name}
                            onChange={(e) => {
                                this.props.onChange({
                                    ...data,
                                    name: e.target.value
                                })
                            }}
                            placeholder="Name"
                        />
                    </div>
                    <div style={{
                        maxWidth: 300,
                        flex: 1, textAlign: 'center', padding: 4
                    }}>
                        <Input
                            placeholder="Display Name"
                        />
                    </div>
                    <div style={{
                        maxWidth: 300,
                        flex: 1, textAlign: 'center', padding: 4
                    }}>
                        <Checkbox
                        />
                    </div>
                    <div style={{
                        maxWidth: 300,
                        flex: 1, textAlign: 'center', padding: 4
                    }}>
                        <Input
                            placeholder="Type"
                        />
                    </div>

                </div>

            </div>
        );
    }
}

export default BasicConfigForm;
